import type { Step } from "@views/Upholstery/types"
import {
  fetchAndMergePdmConfigurableSteps,
  fetchPdmProductsRecords,
} from "@views/Upholstery/pdm/pdmStepsClient"
import { isPdmStructureV2Enabled } from "../flags/isPdmStructureV2Enabled"
import { mergeConfigurableStepsFromPdmProducts } from "./buildConfigurableStepsFromPdmProducts"
import {
  DatoStepsMissingError,
  PDM_PRODUCTS_UNAVAILABLE_ERROR,
} from "../vehicle/vehicleSelectionErrors"

export async function resolveStepsWithPdm(
  vehicle: {
    steps: Step[]
    sku: string
  },
  make: string,
  model: string,
  year: string
): Promise<Step[]> {
  const usePdmStructureV2 = isPdmStructureV2Enabled()

  if (usePdmStructureV2) {
    const products = await fetchPdmProductsRecords()

    if (!products?.length) {
      throw new Error(PDM_PRODUCTS_UNAVAILABLE_ERROR)
    }

    if (!vehicle.steps?.length) {
      throw new DatoStepsMissingError(make, model, year)
    }

    const stepsWithPdm = await mergeConfigurableStepsFromPdmProducts(
      vehicle.steps,
      { make, model, years: year },
      products
    )

    return stepsWithPdm
  }

  return fetchAndMergePdmConfigurableSteps(vehicle.steps, vehicle.sku)
}
